export default "__VITE_ASSET__dcf4eeeb__"